module.exports = __webpack_public_path__ + "static/media/CV.71258aa0.png";